module.exports = __webpack_public_path__ + "static/img/aboutItem1.52fe432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/aboutItem1.png
// module id = dpxa
// module chunks = 0